import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useSearchParams } from 'react-router-dom';
import { EXCHANGE_RESULT_VARIANTS, ExchangeSection } from '@/features/exchange';
import { MarketSection } from '@/widgets/market-assets';

type PageSectionProps = {
  title: string;
  children: ReactNode;
};

const PageSection = ({ title, children }: PageSectionProps) => (
  <section className="flex w-full flex-col gap-[1.6rem] tablet:flex-1 tablet:min-w-0">
    <h1 className="headline4">{title}</h1>
    {children}
  </section>
);

const ExchangePage = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const initialAssetFrom = (state as { asset?: string } | null)?.asset;
  const initialAssetTo = searchParams.get('assetTo') ?? undefined;

  return (
    <div className="grow px-[2.4rem] tablet:px-[3.6rem] py-[1.8rem]">
      <div className="flex w-full flex-col items-start gap-[4.2rem] tablet:flex-row tablet:gap-[5.4rem]">
        <PageSection title={t('exchange.title')}>
          <ExchangeSection
            variant={EXCHANGE_RESULT_VARIANTS.PAGE}
            initialAssetFrom={initialAssetFrom}
            initialAssetTo={initialAssetTo}
          />
        </PageSection>

        <PageSection title={t('personalAccount.overview.sections.market')}>
          <MarketSection />
        </PageSection>
      </div>
    </div>
  );
};

export { ExchangePage };
